document.addEventListener("DOMContentLoaded", function () {
  const productPack = document.querySelector("product-pack");
  if (!productPack) return;
  const productPackSelects = productPack.querySelectorAll(
    ".product-pack-select"
  );
  const productPackContents = productPack.querySelectorAll(
    ".product-pack__content"
  );

  const button_add_to_cart =
    document.querySelector(".product-info .add-to-cart") ||
    document.querySelector(".product-info [data-action='add-to-cart']");

  const button_add_to_cart_custom = document.querySelector(
    ".pack-custom-add-to-cart"
  );
  const isQvemaContext = !!document.querySelector(".product-info .qvema-add-to-cart");

  const section = productPack.closest('[data-section-type="main-product"]');
  const firstSlideImg = section
    ? section.querySelector(
        ".product-media > .swiper:first-child .swiper-slide:first-child img"
      )
    : null;

  if (!isQvemaContext) {
    productPackSelects.forEach((select, index) => {
      select.addEventListener("click", () => {
        productPackSelects.forEach((s) => s.classList.remove("active"));
        productPackContents.forEach((c) => c.classList.remove("active"));

        select.classList.add("active");
        productPackContents[index].classList.add("active");

        const pack_price =
          productPackContents[index].getAttribute("data-pack-price");
        const pack_id = productPackContents[index].getAttribute("data-pack-id");

        if (button_add_to_cart && pack_id && pack_price) {
          button_add_to_cart.setAttribute("data-variant-id", pack_id);
          const span = button_add_to_cart.querySelector("span");
          if (span) {
            span.innerHTML = `Ajouter au panier&nbsp;|&nbsp;${pack_price}`;
          }
        }

        if (button_add_to_cart_custom && button_add_to_cart) {
          if (index === productPackSelects.length - 1) {
            button_add_to_cart.classList.add("hidden");
            button_add_to_cart_custom.classList.remove("hidden");
          } else {
            button_add_to_cart.classList.remove("hidden");
            button_add_to_cart_custom.classList.add("hidden");
          }
        }
      });
    });
  }

  document.addEventListener("click", (event) => {
    const button = event.target.closest(".product-pack-switch");
    if (!button) return;
    const content = button.closest(".product-pack__content");
    if (!content) return;

    const group = content.querySelectorAll(".product-pack-switch");
    group.forEach((b) => b.classList.remove("active"));
    button.classList.add("active");

    const packId = button.getAttribute("data-pack-id");
    const packPrice = button.getAttribute("data-pack-price");
    if (packId) content.setAttribute("data-pack-id", packId);
    if (packPrice) content.setAttribute("data-pack-price", packPrice);

    const baseId = content.getAttribute("data-pack-base-id");
    const linkedId = content.getAttribute("data-pack-linked-id");
    const listBase = content.querySelector('[data-pack-list="base"]');
    const listLinked = content.querySelector('[data-pack-list="linked"]');

    if (listBase && listLinked) {
      if (linkedId && packId === linkedId) {
        listBase.classList.add("hidden");
        listLinked.classList.remove("hidden");
      } else {
        listLinked.classList.add("hidden");
        listBase.classList.remove("hidden");
      }
    }

    const section = button.closest('[data-section-type="main-product"]');
    const addToCartBtn = section
      ? section.querySelector(".product-info .add-to-cart") ||
        section.querySelector(".product-info [data-action='add-to-cart']")
      : null;
    const firstSlideImg = section
      ? section.querySelector(
          ".product-media > .swiper:first-child .swiper-slide:first-child img"
        )
      : null;

    if (addToCartBtn && packId && packPrice) {
      addToCartBtn.setAttribute("data-variant-id", packId);
      const span = addToCartBtn.querySelector("span");
      if (span) {
        span.innerHTML = `Ajouter au panier&nbsp;|&nbsp;${packPrice}`;
      }
    }

    // Update featured image from the switch button's data attributes
    const imageToUse = button.getAttribute("data-pack-image");
    const altToUse = button.getAttribute("data-pack-image-alt");

    if (firstSlideImg && imageToUse) {
      firstSlideImg.setAttribute("src", imageToUse);
      firstSlideImg.removeAttribute("srcset");
      if (altToUse) {
        firstSlideImg.setAttribute("alt", altToUse);
      }

      // Slide back to first image
      const swiperEl = section.querySelector(".product-media > .swiper:first-child");
      if (swiperEl && swiperEl.swiper) {
        swiperEl.swiper.slideTo(0);
      }
    }
  });
});

if (!customElements.get("pack-builder")) {
  class PackBuilderElement extends HTMLElement {
    constructor() {
      super();
      this.selections = {};
      this.selection_qty = 0;
      this.buttonsIncrement = this.querySelectorAll(
        '.button.button--primary.pack-add, [data-action="increment"]'
      );

    this.addToCartGeneral = document.querySelector(
      '.product-form [data-action="add-to-cart"]'
    );
    this.selectsQuantity = this.querySelectorAll(".product-pack-select-custom");
    this.currentQty = parseInt(
      this.querySelector(".product-pack-select-custom.active").getAttribute(
        "data-quantity"
      )
    );
    this.currentDiscount = this.querySelector(
      ".product-pack-select-custom.active"
    ).getAttribute("discount");
    this.packItemsAdd = this.querySelectorAll(".pack-add");
    this.packItemsQtySelector = this.querySelectorAll(
      ".quantity-selector__qty"
    );

    this.buttonAddToCart = this.querySelector(".pack-custom-add-to-cart");

    this.init();
  }

  init() {
    this.selectsQuantity.forEach((select) => {
      select.addEventListener("click", () => {
        this.selectsQuantity.forEach((s) => s.classList.remove("active"));
        select.classList.add("active");
        this.currentQty = parseInt(select.getAttribute("data-quantity"));
        this.currentDiscount = select.getAttribute("discount");

        if (this.selection_qty > this.currentQty) {
          this.querySelectorAll("quantity-selector").forEach((selector) => {
            selector.querySelector(".quantity-selector__qty-input").value = 0;
            selector
              .querySelector(".quantity-selector__qty")
              .classList.add("hidden");
            selector.querySelector(".pack-add").classList.remove("hidden");
            this.selection_qty = 0;
          });
          this.selections = {};
        }
        this.updateButtonAddToCart();
      });
    });

    this.packItemsAdd.forEach((button) => {
      button.addEventListener("click", () => {
        button.nextElementSibling
          .querySelector('[data-action="increment"]')
          .click();
      });
    });

    this.packItemsQtySelector.forEach((selector) => {
      const increment = selector.querySelector('[data-action="increment"]');
      const decrement = selector.querySelector('[data-action="decrement"]');
      const qty = selector.querySelector("span");
      const input = selector.querySelector(".quantity-selector__qty-input");
      const variant_id = selector
        .closest(".pack-item")
        .getAttribute("data-variant-id");

      increment.addEventListener("click", () => {
        let totalQty = Array.from(
          this.querySelectorAll(".quantity-selector__qty-input")
        ).reduce((acc, item) => acc + parseInt(item.value), 0);

        console.log(totalQty);

        if (totalQty < this.currentQty) {
          input.value = parseInt(input.value) + 1;
          qty.innerHTML = input.value;
          totalQty += 1;

          increment
            .closest("quantity-selector")
            .querySelector(".pack-add")
            .classList.add("hidden");

          increment
            .closest("quantity-selector")
            .querySelector(".quantity-selector__qty")
            .classList.remove("hidden");
        }

        if (totalQty === this.currentQty) {
          this.buttonsIncrement.forEach((button) => {
            button.disabled = true;
          });
        }

        this.updateButtonAddToCart();
      });

      decrement.addEventListener("click", () => {
        let totalQty = Array.from(
          this.querySelectorAll(".quantity-selector__qty-input")
        ).reduce((acc, item) => acc + parseInt(item.value), 0);

        if (parseInt(input.value) > 1) {
          input.value = parseInt(input.value) - 1;
          qty.innerHTML = input.value;
        } else {
          input.value = 0;
          qty.innerHTML = 0;
          decrement
            .closest("quantity-selector")
            .querySelector(".pack-add")
            .classList.remove("hidden");

          decrement
            .closest("quantity-selector")
            .querySelector(".quantity-selector__qty")
            .classList.add("hidden");
        }

        this.buttonsIncrement.forEach((button) => {
          button.disabled = false;
        });

        this.updateButtonAddToCart();
      });
    });
  }

  updateButtonAddToCart() {
    const selectedItems = this.querySelectorAll(
      ".quantity-selector__qty-input"
    );

    let totalQty = Array.from(selectedItems).reduce(
      (acc, item) => acc + parseInt(item.value),
      0
    );

    this.selection_qty = totalQty;

    let remaining_selection = `${totalQty}/${this.currentQty} parfums sélectionnés`;
    this.buttonAddToCart.innerHTML = remaining_selection;

    this.buttonAddToCart.disabled = totalQty !== this.currentQty;

    console.log(totalQty, this.currentQty);
    if (totalQty === this.currentQty) {
      this.buttonAddToCart.innerHTML = `Ajouter au panier`;
    }

    if (totalQty < this.currentQty) {
      // update all increment button
      this.buttonsIncrement.forEach((button) => {
        button.disabled = false;
      });
    } else {
      // update all increment button
      this.buttonsIncrement.forEach((button) => {
        button.disabled = true;
      });
    }

    this.updateComposition();
  }

  updateComposition() {
    const selectedItems = this.querySelectorAll(".pack-item");

    selectedItems.forEach((item) => {
      const variant_id = item.getAttribute("data-variant-id");
      const qty = parseInt(
        item.querySelector(".quantity-selector__qty-input").value
      );

      console.log(qty);

      this.selections[variant_id] = qty;
    });

    console.log(this.selections);
  }

  removeItems() {
    const selectedItems = this.querySelectorAll(
      ".quantity-selector__qty-input"
    );

    Array.from(selectedItems).forEach((item) => {
      if (parseInt(item.value) > 0) {
        item.value = 0;
        item.nextElementSibling.innerHTML = 0;
        item.closest(".quantity-selector__qty").classList.add("hidden");
        item
          .closest(".quantity-selector__qty")
          .previousElementSibling.classList.remove("hidden");
      }
    });
    }
  }

  customElements.define("pack-builder", PackBuilderElement);
}
